import { Grid, Typography } from '@mui/material';
import { useSarlaftStrategicAlly } from './hook';
import { SarlaftStrategicAllyProps } from './props';
import FieldText from '../../../../../components/general/fields/fieldText';
import SearchIcon from '@mui/icons-material/Search';
import { Dialog } from '../../../../../components/general/dialog/dialog';
import { StrategicAlly } from '../../../strategicAlly';

export const SarlaftStrategicAlly = (props: SarlaftStrategicAllyProps) => {
    const { formik, handleChangeStrategicAlly, handleChangeOpenDialog, open } =
        useSarlaftStrategicAlly(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Aliado estratégico
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Aliado estratégico"
                    name="strategicAlly"
                    size="small"
                    disabled
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.strategicAlly}
                    errors={formik.errors.strategicAlly}
                    value={(formik.values as any).strategicAllyLabel}
                    onClickIcon={handleChangeOpenDialog}
                    Icon={SearchIcon}
                />
            </Grid>
            <Dialog
                open={open}
                onClose={() => handleChangeStrategicAlly()}
                title="Buscar aliado estratégico"
            >
                <StrategicAlly
                    showTitle={false}
                    onClickRow={handleChangeStrategicAlly}
                />
            </Dialog>
        </Grid>
    );
};
